module.exports = __webpack_public_path__ + "img/vitrologo.8ab45e84.png";